import React from 'react';
import { Star, Shield, Zap, Circle } from 'lucide-react';

type Tier = 'free' | 'standard' | 'enhanced' | 'featured';

const tierConfig: Record<Tier, { label: string; icon: React.ReactNode; className: string }> = {
  free: {
    label: 'Free',
    icon: <Circle size={10} />,
    className: 'tier-badge tier-badge-free',
  },
  standard: {
    label: 'Standard',
    icon: <Zap size={10} />,
    className: 'tier-badge tier-badge-standard',
  },
  enhanced: {
    label: 'Enhanced',
    icon: <Shield size={10} />,
    className: 'tier-badge tier-badge-enhanced',
  },
  featured: {
    label: 'Featured',
    icon: <Star size={10} />,
    className: 'tier-badge tier-badge-featured',
  },
};

export default function TierBadge({ tier }: { tier: Tier }) {
  const config = tierConfig[tier];
  return (
    <span className={config.className}>
      {config.icon}
      {config.label}
    </span>
  );
}